//----------------------------------------
// slider.js
// Author: @codymarcoux (Studio123)
//----------------------------------------
var isDragging = false;

function initCards(section){
  var drugCardsBlocks = $('.block--drug-options');

  if(section){
    var drugCardsBlocks = $(section).find('.block--drug-options');
  }

  if(drugCardsBlocks.length > 0){
    drugCardsBlocks.each(function(i, section) {
      if($(this).find('.slider')[0]){
        var cardScrollbar = Scrollbar.init(
          $(this).find('.slider')[0], {
            alwaysShowTracks: true,
            renderByPixels: false
          }
        );


        $(section).find('.slider').on('mousedown', function(e){ 
          cardScrollbar.scrollLeft = onMouseDown(e, cardScrollbar.scrollLeft);
        });

        $(section).find('.slider').on('mousemove', function(e){ 
          cardScrollbar.scrollLeft = onMouseMove(e, cardScrollbar.scrollLeft);
          
          if(isDragging === true){
            $(cardScrollbar.containerEl).addClass('is-dragging');
          }
        });

        $(section).find('.slider').on('mouseup', function(e) {
          cardScrollbar.scrollLeft = onMouseUp(e, cardScrollbar.scrollLeft)

          if(isDragging === false){
            $(cardScrollbar.containerEl).removeClass('is-dragging');
          }
        });

          // $(section).find('.slider').on('mouseleave', function(e) {
          //   cardScrollbar.scrollLeft = onMouseLeave(e, cardScrollbar.scrollLeft)

          //   if(isDragging === false){
          //     $(cardScrollbar.containerEl).removeClass('is-dragging');
          //   }
          // });
      }
    });
  }
}

function onMouseDown(e, currentScrollPos) {
  startx = e.clientX + currentScrollPos;
  diffx = 0;
  isDragging = true;
}

function onMouseMove(e, currentScrollPos) {
  if (isDragging === true) {
      diffx = (this.startx - (e.clientX + currentScrollPos));
      return currentScrollPos += diffx;
  }
}

function onMouseUp(e, currentScrollPos) {
  isDragging = false;
  return currentScrollPos;
}

function onMouseLeave(e, currentScrollPos) {
  isDragging = false;
  return currentScrollPos;
}